import * as THREE from 'three'
import { contactLinks } from '../../data/portfolioContent.js'

export default class InformationSection
{
    constructor(_options)
    {
        // Options
        this.time = _options.time
        this.resources = _options.resources
        this.objects = _options.objects
        this.areas = _options.areas
        this.tiles = _options.tiles
        this.debug = _options.debug
        this.x = _options.x
        this.y = _options.y

        // Set up
        this.container = new THREE.Object3D()
        this.container.matrixAutoUpdate = false

        this.setStatic()
        this.setLinks()
        this.setTiles()
    }

    setStatic()
    {
        this.removeTwitter()

        this.objects.add({
            base: this.resources.items.informationStaticBase.scene,
            collision: this.resources.items.informationStaticCollision.scene,
            floorShadowTexture: this.resources.items.informationStaticFloorShadowTexture,
            offset: new THREE.Vector3(this.x, this.y, 0),
            mass: 0
        })
    }

    removeTwitter()
    {
        const hidden = new Set([
            'shadeOrange.005',
            'shadeOrange005',
            'shadeWhite_033',
            'Cube.063',
            'Cube063',
            'Cube.067',
            'Cube067',
            'shadeGray.007',
            'shadeGray007',
            'shadeWhite.111',
            'shadeWhite111',
            'shadeWhite',
            'shadeWhite.112',
            'shadeWhite112',
            'shadeRed.005',
            'shadeRed005',
            'shadeBlue',
            'shadeRed.001',
            'shadeRed001',
            'Cube.055',
            'Cube055',
            'Cube.057',
            'Cube057',
            'Cube.058',
            'Cube058',
            'Cube.059',
            'Cube059',
            'Cube',
        ])

        const scenes = [
            this.resources.items.informationStaticBase.scene,
            this.resources.items.informationStaticCollision.scene,
        ]

        for(const scene of scenes)
        {
            const remove = []

            scene.traverse((child) =>
            {
                if(hidden.has(child.name) || hidden.has(child.userData.name))
                {
                    remove.push(child)
                }
            })

            for(const child of remove)
            {
                child.removeFromParent()
            }
        }
    }

    setLinks()
    {
        // Set up
        this.links = {}
        this.links.x = 1.95
        this.links.y = - 1.5
        this.links.halfExtents = {}
        this.links.halfExtents.x = 1
        this.links.halfExtents.y = 1
        this.links.distanceBetween = 2.4
        this.links.labelWidth = this.links.halfExtents.x * 2 + 1
        this.links.labelGeometry = new THREE.PlaneGeometry(this.links.labelWidth, this.links.labelWidth * 0.25, 1, 1)
        this.links.labelOffset = - 1.6
        this.links.items = []

        this.links.container = new THREE.Object3D()
        this.links.container.matrixAutoUpdate = false
        this.container.add(this.links.container)

        // Options
        const labelTextures = {
            informationContactGithubLabel: this.resources.items.informationContactGithubLabelTexture,
            informationContactLinkedinLabel: this.resources.items.informationContactLinkedinLabelTexture,
            informationContactMailLabel: this.resources.items.informationContactMailLabelTexture,
        }

        this.links.options = contactLinks.map((link) => ({
            href: link.href,
            labelTexture: labelTextures[link.textureKey],
            slot: link.slot,
        }))

        // Create each link
        let i = 0
        for(const _option of this.links.options)
        {
            // Set up
            const item = {}
            const slot = _option.slot ?? i
            item.x = this.x + this.links.x + this.links.distanceBetween * slot
            item.y = this.y + this.links.y
            item.href = _option.href

            // Create area
            item.area = this.areas.add({
                position: new THREE.Vector2(item.x, item.y),
                halfExtents: new THREE.Vector2(this.links.halfExtents.x, this.links.halfExtents.y)
            })
            item.area.on('interact', () =>
            {
                window.open(_option.href, '_blank')
            })

            // Texture
            item.texture = _option.labelTexture
            item.texture.magFilter = THREE.NearestFilter
            item.texture.minFilter = THREE.LinearFilter

            // Create label
            item.labelMesh = new THREE.Mesh(this.links.labelGeometry, new THREE.MeshBasicMaterial({ wireframe: false, color: 0xffffff, alphaMap: _option.labelTexture, depthTest: true, depthWrite: false, transparent: true }))
            item.labelMesh.position.x = item.x + this.links.labelWidth * 0.5 - this.links.halfExtents.x
            item.labelMesh.position.y = item.y + this.links.labelOffset
            item.labelMesh.matrixAutoUpdate = false
            item.labelMesh.updateMatrix()
            this.links.container.add(item.labelMesh)

            // Save
            this.links.items.push(item)

            i++
        }
    }

    setTiles()
    {
        this.tiles.add({
            start: new THREE.Vector2(this.x - 1.2, this.y + 13),
            delta: new THREE.Vector2(0, - 20)
        })
    }
}
